import { render } from "./WordLengthComp.vue?vue&type=template&id=e15a2b5c&scoped=true"
import script from "./WordLengthComp.vue?vue&type=script&lang=js"
export * from "./WordLengthComp.vue?vue&type=script&lang=js"

import "./WordLengthComp.vue?vue&type=style&index=0&id=e15a2b5c&scoped=true&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\VueJs\\hangman\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e15a2b5c"]])

export default __exports__